export const formFieldNames = {
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  displayName: 'displayName',
  avatarColor: 'avatarColor',
  timezone: 'timezone'
} as const;
